import { render, staticRenderFns } from "./mint-butlers-dev.vue?vue&type=template&id=606a0497&scoped=true&"
import script from "./mint-butlers-dev.vue?vue&type=script&lang=js&"
export * from "./mint-butlers-dev.vue?vue&type=script&lang=js&"
import style0 from "./mint-butlers-dev.vue?vue&type=style&index=0&id=606a0497&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606a0497",
  null
  
)

export default component.exports